import { Dialog } from '../Dialog';

import classes from './confirmDialog.module.css';

interface ConfirmDialogProps {
  headerText: string;
  bodyText: string;
  cancelText?: string;
  confirmText?: string;
  onCancel?: ()=>void;
  onConfirm?: ()=>void;
  variant?: 'danger' | 'default' ;
}

/**
 *
 * @param
 * @returns ConfirmDialog component
 */
export const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  headerText, bodyText, cancelText = 'Cancel', confirmText = 'Confirm', onCancel, onConfirm, variant = 'default',
}) => {
  return (
    <Dialog
      headerText={headerText}
      cancelText={cancelText}
      confirmText={confirmText}
      onCancel={onCancel}
      onConfirm={onConfirm}
      variant={variant}
    >
      <p className={classes.bodyText}>{bodyText}</p>
    </Dialog>
  );
};
